// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { State } from 'types/redux';
import type { Props } from './LandingPage';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { gtmStartCheckInClick } from 'store/reducers/gtm/actions';
// Selectors
import { getVehicle, getStartTime } from 'store/reducers/appointment/selectors';
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';
import {
  getSelfCheckInFlow,
  getInitialLoadingComplete
} from 'store/reducers/selfCheckIn/selectors';
import { getErrorType } from 'store/reducers/appointment/selfCheckIn/selectors';

// Component
import LandingPage from './LandingPage';

const mapStateToProps = (state: State): $Shape<Props> => ({
  vehicle: getVehicle(state),
  dealerCountryCode: getDealerCountryCode(state),
  startTime: getStartTime(state),
  selfCheckInFlow: getSelfCheckInFlow(state),
  selfCheckInError: getErrorType(state),
  initialLoadingComplete: getInitialLoadingComplete(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      gtmStartCheckInClick
    }
  )
)(LandingPage);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/LandingPage/LandingPageContainer.js